var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.7053 7.77254L0.825321 14.6315L0.825321 0.913617L12.7053 7.77254Z","fill":"#383838"}));
}

PlayButton.defaultProps = {"width":"13","height":"15","viewBox":"0 0 13 15","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
